import React from "react";
import DOMPurify from "dompurify";

const looksLikeHtml = (str = "") => /<\/?[a-z][\s\S]*>/i.test(str);

export const MenuRow = ({ item, rowClass = "" }) => {
    const desc       = item.description ?? "";
    const isHtmlDesc = looksLikeHtml(desc);

    return (
        <div className={`row ${rowClass}`}>
            <div className="col-6 title">
                {item.title}

                {desc && (
                    <>
                        <br />
                        {isHtmlDesc ? (
                            <small
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(desc),
                                }}
                            />
                        ) : (
                            <small>({desc})</small>
                        )}
                    </>
                )}
            </div>

            <div className="col-2 exit">
                {rowClass ? item.exit : item.exit.split("/").join(" / ")}
            </div>

            <div className="col-2 price">
                {rowClass
                    ? item.price
                    : parseFloat(item.price) === 0
                        ? "-"
                        : parseFloat(item.price)}
            </div>
        </div>
    );
};